export default __webpack_public_path__ + "static/media/homepage.e027b46f.jpg";